import { buildApiUrl } from '../utils/apiSetup';
const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
  if (json) headers['Content-Type'] = 'application/json';
  return headers;
};

const parseError = async (response, fallback) => {
  try {
    const data = await response.json();
    if (typeof data.detail === 'string') return data.detail;
    if (Array.isArray(data.detail) && data.detail.length > 0) {
      return data.detail[0].msg || fallback;
    }
  } catch {
    /* ignore */
  }
  return fallback;
};

export async function fetchMyVpfRequest(signal) {
  const response = await fetch(buildApiUrl('/api/v1/vpf/my-request'), {
    headers: authHeaders(false),
    signal,
  });
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load VPF request'));
  return response.json();
}

export async function fetchMyVpfHistory(signal) {
  const response = await fetch(buildApiUrl('/api/v1/vpf/history'), {
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load VPF history'));
  return response.json();
}

export async function createVpfRequest(payload, signal) {
  const response = await fetch(buildApiUrl('/api/v1/vpf/request'), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to create VPF request'));
  return response.json();
}

export async function updateVpfRequest(requestId, payload, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/request/${requestId}`), {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to update VPF request'));
  return response.json();
}

export async function cancelVpfRequest(requestId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/request/${requestId}`), {
    method: 'DELETE',
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to cancel VPF request'));
  return response.json();
}

export async function fetchEmployeeVpfContext(employeeId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/employee/${employeeId}`), {
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load VPF context'));
  return response.json();
}

export async function approveVpfRequest(requestId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/request/${requestId}/approve`), {
    method: 'POST',
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to approve VPF request'));
  return response.json();
}

export async function rejectVpfRequest(requestId, rejectionReason, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/request/${requestId}/reject`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ rejection_reason: rejectionReason }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to reject VPF request'));
  return response.json();
}

export async function closeVpfRequest(requestId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/request/${requestId}/close`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ confirm: true }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to close VPF request'));
  return response.json();
}

export async function createEmployeeVpfRequest(employeeId, payload, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/employee/${employeeId}/request`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to create employee VPF request'));
  return response.json();
}

export async function fetchEmployeeVpfHistory(employeeId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/vpf/employee/${employeeId}/history`), {
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee VPF history'));
  return response.json();
}

